import {CustomError, ErrorPresentModes} from "@kta20-core/errors/custom-error";
import {en as T} from "@kta20-core/resources/lang/en"; //here is safe to use english only

export class FetchError extends CustomError {
    constructor(message?) {
        super(message ? (message + ' [err: FETCHE]') : T.cannot_get_or_send_data_from_server);
        this.name = 'FetchError';
        this.presentMode = ErrorPresentModes.DETAILS_TO_USER;
    }
}